// extracted by css-extract-rspack-plugin
export default {"filterSelect":"Abc1w5maVIBV7ffY"};